import { Box } from "@mui/material";
import CROSS from "../../../assets/images/CROSS.svg";
import LogoSvg from "../../atoms/LogoSvg/LogoSvg";
import Title from "../../atoms/Title/Title";
import Text from "../../atoms/Text/Text";
import StyledButton from "../../atoms/StyledButton/StyledButton";
import Modal from "../../atoms/Modal/Modal";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  buttonLabel: string;
  onButtonClick: () => void;
  secondButtonLabel?: string;
  onSecondButtonClick?: () => void;
}

const PopIn = ({ isOpen, onClose, title, description, buttonLabel, onButtonClick, secondButtonLabel, onSecondButtonClick }: Props) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box className="PopIn">
        <Box className="popInClosingCross">
          <LogoSvg src={CROSS} className="logo" onClick={onClose} />
        </Box>
        <Title variant="h1" children={title} />
        {description && <Text children={description} />}
        <StyledButton children={buttonLabel} onClick={onButtonClick} />
        {secondButtonLabel && onSecondButtonClick && (
          <StyledButton className="white" children={secondButtonLabel} onClick={onSecondButtonClick} />
        )}
      </Box>
    </Modal>
  );
};

export default PopIn;
